<template>
  <b-button
    @click="showModal"
    size="sm"
    :disabled="disabled"
    :variant="(httpRequestInProgress) ? 'success': 'primary'"
    block
    v-show="!userPreferenceStore.coi.lightMode"
  >
    <!-- button -->
    <span v-if="httpRequestInProgress">
      <b-spinner
      type="grow"
      label="Loading..."
      small
      ></b-spinner>
    </span>
    <span v-else-if="customerOrder.postalReturnAt != null">Postrückläufer: {{moment(customerOrder.postalReturnAt).locale("de").format('L')}}</span>
    <span v-else>Als Postrückläufer markieren</span>

    <b-modal id="modal-center" 
    no-close-on-backdrop
    hide-footer
    centered 
    title="Postrückläufer Webcam Modal" 
    v-model="modalState"
    size="lg"
    @hidden="onCancel()"
    >
        <b-row>
          <b-col cols="9" >
            <div v-show="!clickedOnImage && !writeMail">
              <vue-web-cam
                ref="webcam"
                :device-id="deviceId"
                width="100%"
                @started="onStarted"
                @stopped="onStopped"
                @error="onError"
                @cameras="onCameras"
                @camera-change="onCameraChange"
              />
            </div>
            <div v-show="clickedOnImage && !writeMail">
              <img :src="this.imageClicked" class="img-fluid" @click="hideImage"/>
            </div>

          </b-col>
          <b-col>
            <div v-if="images.length >0" class="latestImages overflow-auto">
              <h3>Letzte Fotos</h3>
              <div v-for="(image,imgId) in this.images" :key="imgId" >
                <div class="position-relative">
                  <b-btn class="downloadButton btn-sm btn-secondary" @click="onDownload(image, customerOrder.id + '.jpg', 'image/jpeg')">
	                  <i class="bi bi-download"></i>
                  </b-btn>
                  <b-btn class="deleteButton btn-sm btn-danger" @click="onDelete(image)">
	                  <i class="bi bi-trash"></i>
                  </b-btn>
                  <img :src="image" class="img-fluid" @click="showImage(image)"/> <!--@click="showImage(image)" -->
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <div class="row">
          <div class="col-md-12 mt-3" >
            <select v-model="camera">
              <option>-- Webcam auswählen --</option>
              <option
                v-for="device in devices"
              :key="device.deviceId"
              :value="device.deviceId"
              >{{ device.label }}</option>
            </select>
          </div>
        <div class="col-md-12 my-4">
          <button v-if="cameraOn" type="button" class="btn btn-primary" @click="onCapture">Foto erzeugen</button>
          <button v-if="!cameraOn" :disabled="clickedOnImage" type="button" class="btn btn-success float-left mr-2" @click="onStart(), cameraOn= !cameraOn">Webcam einschalten</button>
          <button v-else type="button" class="btn btn-danger float-left mr-2" @click="onStop(), cameraOn= !cameraOn">Webcam ausschalten</button>
            
          <button v-if="isShippingServiceDHL && this.images.length > 0" type="button" :disabled="saveDisabled" class="btn btn-primary float-right" @click="writeMail = !writeMail"><i class="bi bi-envelope"></i> E-Mail schreiben</button>
          <button type="button" :disabled="saveDisabled" class="btn btn-primary float-right mr-2" @click="store()">{{ customerOrder.postalReturnAt == null ? "Als Rückläufer markieren" : "Speichern" }}</button>
          <button v-if="customerOrder.postalReturnAt != null" type="button" class="btn btn-primary float-right mr-2" @click="submitRevert()">Markierung entfernen</button>
        </div>
      </div>
      <div v-if="writeMail">
        <hr>
        <b-form-group label-cols="4" label-cols-lg="2" label="Rechnungsnummer" label-for="input-default">
          <b-form-input id="input-default" v-model="claimMail.invoiceNumber"></b-form-input>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-lg="2" label="Sendungsnummer" label-for="input-default">
          <b-form-input id="input-default" :disabled="true" v-model="shippingId"></b-form-input>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-lg="2" label="Reklamationsgrund" label-for="input-default">
           <b-form-select v-model="claimReasonSelected" :options="claimReasonOptions"></b-form-select>
           <b-form-textarea id="input-default" :disabled="true" v-model="claimReasonSelected.reasonDescription" rows="2" max-rows="3"></b-form-textarea>
        </b-form-group>
        <div class="text-center">
          <b-btn variant="primary" @click="sendEmail()"><i class="bi bi-envelope"></i> E-Mail senden</b-btn>
        </div>
      </div>
    </b-modal>
  </b-button>
</template>

<script>
import axios from 'axios';
import { useUserPreferenceStore } from '../../stores/UserPreferenceStore';

export default {
  setup(){
    const userPreferenceStore = useUserPreferenceStore();
    return {userPreferenceStore}
  },
  name: "COIActionBarPostalReturn",
  props: ['customerOrder','authorization'],
  data() {
    return {
      modalState: false,
      user: null,
      devices: [],
      deviceId: null,
      camera: null,
      cameraOn: false,
      img: null,
      //mit Prefix
      images: [],
      imgPrefix: 'data:image/jpeg;base64,',
      //ohne Prefix - Wird nur befüllt wenn Daten im Backend schon sind oder man dorthin welche speichern will
      imagesToStore: [],
      picReference: '',
      imageClicked: null,
      clickedOnImage: false,
      httpRequestInProgress: false,
      shippingServiceId: null,
      shippingId: null,
      writeMail: false,
      claimReasons: [],
      claimReasonSelected: {
        reason: null,
        reasonDescription: null,
      },
      claimMail :{
        subject: '',
        invoiceNumber: null,
        mail: '',
        shippingId: null,   //Sendungsnummer
        reason: '',
        reasonDescription: ''
      }
    };
  },
  httpRequestInProgress: false,
  computed: {
    device: function() {
            return this.devices.find(n => n.deviceId === this.deviceId);
        },
    disabled: function() {
      // TODO: is it needed to disable the function in some cases? // Justin: nicht von mir
      return this.customerOrder.postalReturnAt != null && !this.authorization.shipping_assistant;
    },

    saveDisabled(){
      if((this.shippingServiceId === 2 || this.shippingServiceId === 5) &&
        this.images.length < 1){
          return true;
        } else {
          return false;
        }
    },
    isShippingServiceDHL(){
      if (this.shippingServiceId == 5 || this.shippingServiceId == 2){
        return true;
      } else {
        return false;
      }
    },
    claimReasonOptions(){
      return this.claimReasons.map(cr => {return { value: cr, text: cr.reason}});
    },
  },
  watch: {
    camera: function(id) {
        this.deviceId = id;
    },
    devices: function() {
        // Once we have a list select the first one
        const [first, ...tail] = this.devices;
        if (first) {
            this.camera = first.deviceId;
            this.deviceId = first.deviceId;
        }
    }
},
//
methods: {
    onCapture() {
        this.img = this.$refs.webcam.capture();
        this.images.push(this.img);
    },
    onStarted(stream) {
        console.log("On Started Event", stream);        
        this.cameraOn = true;    
    },
    onStopped(stream) {
        console.log("On Stopped Event", stream);
    },
    onStop() {
        this.$refs.webcam.stop();
    },
    showImage(image){
      this.imageClicked = image;
      this.clickedOnImage = true;
      this.cameraOn = false;
    },
    hideImage(){
      this.imageClicked = null;
      this.clickedOnImage = false;
      this.cameraOn = true;
    },
    onStart() {
      Vue.nextTick( () => {
        this.$refs.webcam.start();
      })
    },
    onError(error) {
        console.log("On Error Event", error);
    },
    onCameras(cameras) {
        this.devices = cameras;
        console.log("On Cameras Event", cameras);
    },
    onCameraChange(deviceId) {
        this.deviceId = deviceId;
        this.camera = deviceId;
        console.log("On Camera Change Event", deviceId);
    },
    cameraChangeState(){
      return !this.cameraOn;
    },
    onCancel(){
      console.log("onCancel");
      this.modalState = false;
      this.cameraOn = false;
      this.httpRequestInProgress = false;
    },
    convertBase64ToBlob(contentType, data)
    {
      const byteCharacters = atob(data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {type: contentType});
      return blob;
    },
    onDownload(data, filename, _type){
      data = data.slice(23, data.length);
      data = this.convertBase64ToBlob('jpeg', data)
      console.log(data);
         var file = new Blob([data], {type: _type});
         if (window.navigator.msSaveOrOpenBlob) // IE10+
            window.navigator.msSaveOrOpenBlob(file, filename);
         else { // Others
            var a = document.createElement("a"),
                     url = URL.createObjectURL(file);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(function() {
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);
            }, 0);
         }
    },
    onDelete(_image){
      this.images = this.images.filter(image => image !== _image);

      _image = _image.slice(23, _image.length);
      this.imagesToStore = this.imagesToStore.filter(image => image !== _image)
    },
    showModal() {
      this.modalState = true;
      this.cameraOn = false;
      this.onStart();
    },
    sendEmail(){
      this.httpRequestInProgress = true;

      this.claimMail.subject = 'Reklamation' + ' Rechnung "' + this.claimMail.invoiceNumber + '"';
      this.claimMail.shippingId = this.shippingId;
      this.claimMail.reason = this.claimReasonSelected.reason;
      this.claimMail.reasonDescription = this.claimReasonSelected.reasonDescription;

      this.claimMail.mail =   '<p>Sehr geehrte Damen und Herren,</p>' +
                              '<p>hiermit reklamieren wir folgende Sendung:</p>' +
                              '<p>Sendungsnummer: '+ this.claimMail.shippingId +'<br>'+
                              ''+this.claimMail.reasonDescription+'</p>' +
                              '<p>Aus diesem Grund erwarten wir eine Gutschrift.</p>' +
                              '<p>Mit freundlichen Grüßen<br>' +
                              'Reklamationsteam Marc und Lukas GmbH</p>';
      let request = 
      {
        customerOrderId: this.customerOrder.id,
        claimMail: this.claimMail
      };
      console.log(request);

      axios.post('customerorder/action/sendemail', request)
      .then(res =>{
        this.onCancel();
        this.httpRequestInProgress = false;
      }).catch(err => {
        console.log(err);
        this.httpRequestInProgress = false;
      });

    },
    store() {
      this.httpRequestInProgress = true;

      this.imagesToStore = this.images.map(image => {
        return image.slice(23, image.length);
      });

      let payload = {

        customerOrderId: this.customerOrder.id,
        postalReturnalImages: this.imagesToStore
      }
      Promise.all([
        axios.post('/customerorder/action/issue_postal_return', payload),
        new Promise(r => setTimeout(r, 500))
      ]).then( response => {
        this.customerOrder.postalReturnAt = moment().format("YYYY-MM-DD HH:mm:ss");
        this.onCancel();
      }).catch( error => {
        alert(error.response.data)
        console.error(error);
        this.httpRequestInProgress = false;
      });
    },
    submitRevert() {
      this.httpRequestInProgress = true;

      let payload = {
        customerOrderId: this.customerOrder.id
      }

      Promise.all([
        axios.post('/customerorder/action/revert_postal_return', payload),
        new Promise(r => setTimeout(r, 500))
      ]).then( response => {
        this.customerOrder.postalReturnAt = null;
        this.onCancel();
      }).catch( error => {
        alert(error.response.data)
        console.error(error);
        this.httpRequestInProgress = false;
      });
    }
  },
  created(){
    Promise.all([
      axios.get("/user/self"),
      axios.get('shipping_service_claim_reason/all')
    ])
    .then(([userResponse, claimReasonResponse]) => {
      // console.log(res);
      this.user = userResponse.data;
      this.claimReasons = claimReasonResponse.data;
    });
    if(this.customerOrder.customerorderitems[0].customerorderitemdeliveryaddition){
      this.shippingServiceId = this.customerOrder.customerorderitems[0].customerorderitemdeliveryaddition.shippingService
      this.shippingId = this.customerOrder.customerorderitems[0].customerorderitemdeliveryaddition.shippingId
    }
    
    if(this.customerOrder.postalReturnImages){
      this.imagesToStore = JSON.parse(this.customerOrder.postalReturnImages);
      this.images = this.imagesToStore.map(image => {
        return this.imgPrefix.concat(image);
      })
    }

  }
}
</script>
<style scoped>
  .latestImages{
    max-height: 500px !important;
  }
  .downloadButton{
    position: absolute;
    bottom: 0px; 
    left: 0px;   
  }
  .deleteButton{
    position: absolute;
    bottom: 0px; 
    right: 0px;    
  }
</style>